<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="车辆编号" prop="vehicle_id">
              <Input disabled="disabled" class="perW30" v-model="infoData.vehicle_id"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="设备编号" prop="device_id">
              <Input disabled="disabled" class="perW30" v-model="infoData.device_id"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="车辆品牌型号" prop="brand_model">
              <Input disabled="disabled" class="perW30" v-model="infoData.brand_model"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="架子号" prop="chassis_number">
              <Input disabled="disabled" class="perW30" v-model="infoData.chassis_number"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="发动机号" prop="engine_number">
              <Input disabled="disabled" class="perW30" v-model="infoData.engine_number"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="车牌号" prop="license_plate">
              <Input disabled="disabled" class="perW30" v-model="infoData.license_plate"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="马力" prop="horsepower">
              <Input disabled="disabled" class="perW30" v-model="infoData.horsepower"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="车主姓名" prop="owner_name">
              <Input disabled="disabled" class="perW30" v-model="infoData.owner_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="车主电话" prop="owner_phone">
              <Input disabled="disabled" class="perW30" v-model="infoData.owner_phone"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="车辆类型" prop="vehicle_type">
              <Input disabled="disabled" class="perW30" v-model="infoData.vehicle_type"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="所属单位" prop="affiliated_unit">
              <Input disabled="disabled" class="perW30" v-model="infoData.affiliated_unit"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="合作社名称" prop="cooperative_name">
              <Input disabled="disabled" class="perW30" v-model="infoData.cooperative_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="安装日期" prop="install_date">
              <Input disabled="disabled" class="perW30" v-model="infoData.install_date"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="安装人" prop="installer">
              <Input disabled="disabled" class="perW30" v-model="infoData.installer"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="更新时间" prop="mtime">
              <Input disabled="disabled" class="perW30" v-model="infoData.mtime"></Input>
            </FormItem>
          </Col>



        </Row>
      </Form>
    </card>

  </div>
</template>
<script>
import {agriculturalMachineryInfoApi} from '@/api/plant/agriculturalMachinery/agriculturalMachinery'

export default {
  name: 'agricultureMachineryInfo',
  data() {
    return {
      infoData: {
        id: 0,
        vehicle_id: '',
        device_id: '',
        brand_model: '',
        chassis_number: '',
        engine_number: '',
        license_plate: '',
        horsepower: '',
        owner_name: '',
        owner_phone: '',
        vehicle_type: '',
        vehicle_type_name: '',
        affiliated_unit: '',
        cooperative_name: '',
        install_date: '',
        installer: '',
        needs_update: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadInfoData(this.$route.params.id)
    }
  },
  methods: {

    // 编辑加载数据
    loadInfoData(id) {
      agriculturalMachineryInfoApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
